import { EN_REQUEST_ERRORS } from '@/services/RequestService/IRequester';
import { IRequestWrap } from '@/server/IServer';
import { ICertGetCIPayload } from '@/models/Cert/interfaces/ICertGetCIPayload';
import { ResponseEither, responseError, responseSuccess } from '@/models/Common/ResponseEither';
import { MemberNewActions } from '@/models/Member/MemberNewActions';
import { MemberNewRequestBuilder } from '@/models/Member/MemberNewRequestBuilder';
import { path, prop } from 'ramda';

const agreedToPromotion = (promotionType: string, agreements): boolean =>
  ({
    MILLION_COUPON_220907: !!path(['event', 'isPromo220907Agreed'], agreements),
  }[promotionType] || false);

const fetchCI = (req: IRequestWrap) => {
  const { memberNo } = req.session;
  return new MemberNewActions(MemberNewRequestBuilder, req).getCert({
    headers: {
      'x-api-key': req.config.MemberAPIKey,
    },
    resources: { memberNo },
  });
};

/**
 * TODO: 서버 및 클라이언트에서 모두 호출하는 로직으로 sunny 구조에서 적절하게 반영할 수 있는 위치로 변경 필요
 * 유틸이 아니지만 우선 여기에 남겨둠
 */
export const getCI = async (req: IRequestWrap): Promise<ResponseEither<ICertGetCIPayload>> => {
  const entity = await fetchCI(req);

  return entity.map(prop('data')).caseOf({
    left: (err) => {
      return err.statusCode === 404 && err.data?.code === 'NOT_EXIST_TOKEN'
        ? responseSuccess(200, { ci: false })
        : responseError(403, EN_REQUEST_ERRORS.AXIOS, {
            query: req.query,
            message: '본인인증이 실패하였습니다.',
          });
    },
    right: ({ ci }) => {
      const promotionType = req.query.promotionType;
      const agreements = req.session.getAgreements();
      const { memberNo } = req.session;
      const { rid } = req.query;
      const isWithPromotionPolling = () => !!ci && rid && memberNo && promotionType;

      return responseSuccess(200, {
        ci: isWithPromotionPolling() && !agreedToPromotion(promotionType, agreements) ? false : !!ci,
      });
    },
  });
};
